import { reactive } from 'vue';

const state = reactive({
  toasts: [],
});

const showToast = (options) => {
  state.toasts.push({ ...options, visible: true, id: Date.now() });
};

const hideToast = (id) => {
  const index = state.toasts.findIndex((toast) => toast.id === id);
  if (index !== -1) {
    state.toasts.splice(index, 1);
  }
};

export const toastStore = {
  state,
  showToast,
  hideToast,
};
